// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__2BTFt","editable":"Avatar_editable__3c687"};